import React from "react";
import { connect } from 'react-redux';
import ProductSpecificationSlider from './c-specification-slider';
import { toggleSpecificationSlider, updateSpecificationData } from '../../actions/productSpecification';
import SpecificationDetails from './c-specification-slider/components/specificationButtonViewContainer';

const ProductSpecification = ({
	specSliderState,
	toggleSpecificationSlider,
	showSellOnline,
	isAddProduct,
	showInstall,
	productSpecification,
	updateSpecificationData,
	editProduct,
	productOrService,
	profileObject,
	toggleValidationModal
}) => {

	function toggleSlider(){
		if(!specSliderState){
			let specs = productSpecification.editablePuvSpecAttributes;
			if(productSpecification.savedPuvSpecAttributes?.length){
				specs = productSpecification.savedPuvSpecAttributes.map(cur => {
					if(['brand','manufacturer','manufactured_details','country_of_origin','importer','importers_detail','price','packaging_length','packaging_weight','packaging_height','packaging_width','expiry_date'].includes(cur.s_nm.toLowerCase())){
						let val = productSpecification.editablePuvSpecAttributes.find(el => el.s_nm == cur.s_nm).userInput.value;
						cur.userInput.value = val;
					}
					return cur;
				})
			}

			updateSpecificationData({
				...productSpecification,
				editablePuvSpecAttributes: specs
			})
		}
		toggleSpecificationSlider({specSlider: !specSliderState});
	}

	const { isTempProd = false, isTemplate = false } = editProduct;
	const isHideSpec = ((isTempProd || isTemplate) && !showSellOnline && productOrService == 'product');
	return (
		<>
			{
				isHideSpec ? null
				: <SpecificationDetails
					toggleSlider={toggleSlider}
					showSellOnline={showSellOnline}
					productOrService={productOrService}
				/>
			}
			{specSliderState ? (
				<ProductSpecificationSlider
					showSellOnline={showSellOnline}
					isAddProduct={isAddProduct}
					showInstall={showInstall}
					productOrService={productOrService}
					toggleValidationModal={toggleValidationModal}
				/>
			) : null}
		</>
	)
}

const mapStateToProps = (state) => {
	return {
		specSliderState: state.productSpecification.specSliderState,
        productSpecification: state.productSpecification,
		editProduct: state?.products?.editProduct || {},
		profileObject: state?.session?.profileObject
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		toggleSpecificationSlider : payload => dispatch(toggleSpecificationSlider(payload)),
		updateSpecificationData : payload => dispatch(updateSpecificationData(payload))
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(ProductSpecification);
